import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import {
  ProfileProviderPF,
  ProfileProviderPJ,
  UserRef,
} from '../../../core/generated';
import { ChatControllerService } from '../../../core/generated/api/chatController.service';
import { Chat } from '../../../core/generated/model/chat';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../../../environments/environment';
import { ProfileProviderPFCacheListService } from '../../services/profile-provider-pf-cache-list.service';
import { ProfileProviderPJCacheListService } from '../../services/profile-provider-pj-cache-list.service';

@Component({
    selector: 'app-dialog-chat-negotiation',
    standalone: true,
    imports: [MaterialModule, FormsModule, ReactiveFormsModule],
    templateUrl: './dialog-chat-negotiation.component.html',
    styleUrl: './dialog-chat-negotiation.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogChatNegotiationComponent implements OnInit, AfterViewInit {
  isMobile = this.deviceService.isMobile();
  data = inject(MAT_DIALOG_DATA);
  messageInput: string = '';
  chats: Chat[] = [];
  user!: UserRef;
  displaySize = 5;
  eventSource: EventSource | undefined;
  @ViewChild('chatDiv') chatDiv: ElementRef | undefined;

  private readonly profileProviderPFCacheListService = inject(ProfileProviderPFCacheListService);
  private readonly profileProviderPJCacheListService = inject(ProfileProviderPJCacheListService);


  constructor(
    private chatService: ChatControllerService,
    private cd: ChangeDetectorRef,
    private deviceService: DeviceDetectorService
  ) { }

  async ngOnInit() {
    await this.getChats();
  }

  ngAfterViewInit(): void {
    this.eventSource = new EventSource(
      environment.apiUrl +
      'chat/stream?customerServiceId=' +
      this.data.negotiation.id
    );
    this.eventSource.onmessage = (event) => {
      const chat: Chat = JSON.parse(event.data);
      this.chats = [chat, ...this.chats];
      this.cd.detectChanges();
    };

    this.eventSource.onerror = (error) => {
      console.error('Erro no SSE:', error);
    };
  }

  ngOnDestroy() {
    if (this.eventSource) {
      this.eventSource.close();
    }
  }

  getChats() {
    this.chatService
      .findByCustomerServiceId(this.data.negotiation.id)
      .subscribe((chats: Chat[]) => {
        this.chats = chats;
        this.cd.detectChanges();
        this.scrollToBottom();
      });
  }

  async sentMessage() {
    if (this.messageInput.length > 0) {
      const chatMessage: Chat = {
        message: this.messageInput
      };

      let chat: Chat = await firstValueFrom(
        this.chatService.save15(this.data.negotiation.id, chatMessage)
      );

      if (chat) {
        await this.getChats();
      }

      this.messageInput = '';
    }
  }

  isUserSender(userSender?: UserRef) {
    return this.data.participantCpfCnpj === userSender?.cpf;
  }

  displayLimit(index: number) {
    return index > this.chats.length - this.displaySize;
  }

  scrollToTop() {
    this.displaySize = this.displaySize + 3;

    if (this.chatDiv) {
      this.chatDiv.nativeElement.scrollTop = 0;
    }
  }

  scrollToBottom() {
    if (this.chatDiv) {
      this.chatDiv.nativeElement.scrollTop =
        this.chatDiv.nativeElement.scrollHeight;
    }
  }

  getName(userSender?: UserRef): string {
    if (!userSender?.cpf) {
      return 'Usuário';
    }
    
    const cpf = userSender.cpf;
    return cpf.length === 11 
      ? (this.getProfilePFDto(cpf).name ?? 'Usuário')
      : (this.getCompanyDto(cpf).companyName ?? 'Empresa');
  }

  getProfilePFDto(cpf: string): ProfileProviderPF {
    const profilePF = this.profileProviderPFCacheListService.findProfileProviderPFByCpf(cpf);
    return profilePF ? profilePF : { name: 'Usuário não encontrado' } as ProfileProviderPF;
  }

  getCompanyDto(cnpj: string): ProfileProviderPJ {
    const pj = this.profileProviderPJCacheListService.findProfileProviderPJByCnpj(cnpj);
    return pj ? pj : { companyName: 'Empresa não encontrada' } as ProfileProviderPJ;
  }
}